import type {
  ReplayRecoverableCommandRequestPathParamType,
  ReplayRecoverableCommandResponseBodyType,
} from "@intelligems/ig-types/functions/billing-workflow/self-serve-recovery/replay-recoverable-command";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { api } from "../../api";
import { billingWorkflowKeys } from "../../queryKeys";
import type { ApiRequest } from "../../types/api";

export type {
  ReplayRecoverableCommandNotReadyErrorType,
  ReplayRecoverableCommandRequestPathParamType,
  ReplayRecoverableCommandResponseBodyType,
} from "@intelligems/ig-types/functions/billing-workflow/self-serve-recovery/replay-recoverable-command";

type ReplayRecoverableCommandVariables = ApiRequest<
  undefined,
  ReplayRecoverableCommandRequestPathParamType
>;

type ReplayRecoverableCommandOptions = Omit<
  UseMutationOptions<
    ReplayRecoverableCommandResponseBodyType,
    Error,
    ReplayRecoverableCommandVariables
  >,
  "mutationFn" | "mutationKey"
>;

export const replayRecoverableCommand = async (
  variables: ReplayRecoverableCommandVariables
): Promise<ReplayRecoverableCommandResponseBodyType> => {
  const resp = await api.post<ReplayRecoverableCommandResponseBodyType>(
    `/v2/billing-workflow/self-serve-recovery/commands/${variables.pathParams.commandId}/replay`,
    undefined
  );

  return resp.data;
};

export const useReplayRecoverableCommand = (
  options?: ReplayRecoverableCommandOptions
) =>
  useMutation<
    ReplayRecoverableCommandResponseBodyType,
    Error,
    ReplayRecoverableCommandVariables
  >({
    ...options,
    mutationKey: billingWorkflowKeys.selfServeRecoveryReplay,
    mutationFn: replayRecoverableCommand,
  });
